import * as React from 'react'
import { observer } from 'mobx-react'
import { QuestionEditorComponentProps } from 'jobs/questions/props'
import DateTimeQuestionViewModel from '../../DateTimeQuestionViewModel'
import DateInput from 'components/inputs/DateInput'

interface Props
  extends QuestionEditorComponentProps<DateTimeQuestionViewModel> {}

export default observer(function DateTimeEditorInput({
  vm,
  disabled,
  onEnterDown,
  onFocus,
  focus$,
  isNotValid,
}: Props) {
  const keyDown = React.useCallback(
    (e: React.KeyboardEvent) => e.key === 'Enter' && onEnterDown?.(e),
    [onEnterDown],
  )
  return (
    <>
      <DateInput
        focus$={focus$}
        onFocus={onFocus}
        value={vm.answer}
        onChange={vm.change}
        includeTime={vm.collectTime}
        disabled={disabled}
        onKeyDown={keyDown}
        // Allow selecting any date as early as the as-of date (Job Created date)
        minDate={vm.disallowPast ? vm.asOfDate : undefined}
        // Allow selecting any date as late as the current time.
        maxDate={vm.disallowFuture ? new Date() : undefined}
        isNotValid={isNotValid}
        dataTest={
          vm.collectTime ? 'datetime-answer-' + vm.id : 'date-answer-' + vm.id
        }
      />
    </>
  )
})
